export const _route = {
  root: '/',
  login: '/login',
  password: {
    create: '/create_password',
    reset: '/password_reset',
    forgot: '/forgot_password'
  },

  welcome: '/welcome',
  share: '/share',
  payment: '/payment',
  profile: '/profile',
  instructions: '/instructions',
  confirmation: '/confirmation',

  patient: {
    unit: (id: string = ':id') => `/patients_list/${id}`,
    add: `/patients_list/add`,
    edit: (id: string = ':id') => `/patients_list/${id}/edit`,
    list: '/patients_list'
  },

  child: {
    unit: (id: string = ':id') => `/children_list/${id}`,
    add: '/children_list/add',
    list: '/children_list'
  },
  abilities: (id: string = ':id') => `/children_list/${id}/abilities`,
  questionnaires: (id: string = ':id') => `/children_list/${id}/questionnaires`,
  games: (id: string = ':id', tourStep?: 1 | 2 | 3 | 4) =>
    `/children_list/${id}/games${tourStep ? `?tour_step=${tourStep}` : ''}`,

  emailHandler: '/email_handler'
}



// WEBPACK FOOTER //
// ./src/routes/config.ts